import { Grid } from '@material-ui/core';
import * as React from 'react';

import { IAgencyService } from '../../../store/models';

import './index.scss';

interface IProps {
    service: IAgencyService;
}

export const ServiceItem: React.FC<IProps> = ({
    service: { title, services }
}) => {
    return (
        <Grid item md={6} xs={12}>
            <div className="serviceItem">
                <div className="serviceItem__title">
                    <h1>{title}</h1>
                </div>
                <div className="serviceItem__services">
                    <Grid container>
                        {services.map(service => (
                            <Grid key={service.id} item xs={12} sm={6}>
                                <p className="serviceItem__services__title">{service.title}</p>
                            </Grid>
                        ))}
                    </Grid>
                </div>
            </div>
        </Grid>
    );
};
